import RestfulService from "../common/RestfulService";

/**
 * TODO Standardise more on RESTfulService when practical.
 * See also dimensions.js, dimensionitem.service.js * 
 */
const dimensionService = new RestfulService("/dimensions");

const _oldList = dimensionService.list;
dimensionService.list = function(params) {
	// HACK the backend uses a non-standard / endpoint for older code -- so call /list
	const idParam = params?.ids?.join(",");
    if (idParam) {
		return _oldList(params);
    }
    return dimensionService.axios.get(this.path+"/list", { params }).then(({ data }) => data);
};

export default dimensionService;
